export default __webpack_public_path__ + "static/media/01_north_flower_c2.20dee471.mp4";